<template>
  <TemplateLayout :id="theme">
    <div slot="main" class="apply-main">
      <Header :title="guideInfo.lesson" :theme="theme"></Header>
      <div class="container tip-active">
        <div class="img-title img-title-1">点击下方激活课程</div>
        <!-- <img class="img-title" src="./assets/title1.svg" /> -->
        <StepActive
          :wechat="guideInfo.wechat"
          :isShowHand="!isShowBottomTip"
          @follow="handleFollow"
        ></StepActive>
      </div>
      <div class="container gif-display">
        <div class="img-title img-title-2">激活步骤演示:</div>
        <div class="gif-content">
          <img class="gif" :src="guideInfo.image" alt />
        </div>
      </div>
      <div class="finally-step">
        <div class="img-title img-title-3">点击下方激活课程</div>
      </div>
    </div>
    <div slot="bottom" class="bottom">
      <BarFollow
        :wechat="guideInfo.wechat"
        :isShowHand="isShowBottomTip"
        class="bar"
        @follow="handleFollow"
      ></BarFollow>
    </div>
    <template slot="fix-items">
      <ModalTip
        :toggle="modalToggle"
        @confirm="handleToWechat"
        @cancel="modalToggle = false"
      ></ModalTip>
    </template>
  </TemplateLayout>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import TemplateLayout from '@/modules/common/TemplateLayout.vue';
import StepActive from './components/StepActive.vue';
import Header from './components/Header.vue';
import BarFollow from './components/BarFollow.vue';
import Observer from '@/lib/dom/Observer';
import ModalTip from './components/ModalTip.vue';
import { clipboardPaste } from '@/lib/util.ts';
export interface IGuide {
  image: string;
  wechat: string;
  lesson: string;
}
@Component({
  components: {
    TemplateLayout,
    Header,
    StepActive,
    BarFollow,
    ModalTip,
  },
  beforeRouteEnter(to: any, from: any, next: Function) {
    window.Al.start();
    window.np.start();
    window.apis.getApplyGuideConfig(to.query).then((res: any) => {
      window.Al.done();
      window.np.done();
      next((vm: ApplyGuide) => {
        if (res.data) {
          vm.guideInfo = res.data;
          vm.theme = to.query.theme || '';
        }
      });
    });
  },
})
export default class ApplyGuide extends Vue {
  isShowBottomTip = false;
  modalToggle = false;
  theme = '';
  guideInfo: IGuide = {
    lesson: '人工智能 python 课',
    image: '',
    wechat: 'python 小课',
  };
  handleFollow() {
    clipboardPaste(this.guideInfo.wechat);
    this.modalToggle = true;
  }
  handleToWechat() {
    this.handlePostBehavior();
    window.location.href = 'weixin://';
    this.modalToggle = false;
  }
  async handlePostBehavior() {
    if (!this.$route.query.mark_id) return;

    const COPY_FEEDBACK_CODE = '1004';
    try {
      await window.apis.postWeiboFeedback({
        mark_id: this.$route.query.mark_id,
        behavior: COPY_FEEDBACK_CODE,
      });
    } catch (error) {}
  }
  mounted() {
    if (/ByteLocale/.test(window.navigator.userAgent)) {
      document.body.style.minHeight = '100vh';
    }
    setTimeout(() => {
      const container = document.getElementById('t-scroll-container');
      const observeTarget = document.getElementById('content-follow-tip');
      if (container && observeTarget) {
        console.log('init observer');
        const observer = new Observer(
          container,
          () => {
            this.isShowBottomTip = false;
          },
          () => {
            this.isShowBottomTip = true;
          }
        );
        observer.observe(observeTarget);
        this.beforeDestroy = () => {
          observer.unobserve();
        };
      }
    });
  }
}
</script>

<style lang="scss" scoped>
$c-width: 691px;
.img-title {
  color: #5444c6;
  font-weight: bolder;
  font-size: 46px;
}
.apply-main {
  display: flex;
  flex-direction: column;
  align-items: center;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .tip-active {
    width: $c-width;
    padding-top: 70px;
    .img-title {
      margin-bottom: 53px;
    }
  }
  .gif-display {
    width: 100%;
    padding-top: 73px;
    .gif-content {
      position: relative;
      width: 100%;
      min-height: 916px;
      margin-top: 48px;
      .gif {
        width: 100%;
      }
      // background: url('./assets/bg-phone.png') center center/100% 100% no-repeat;
    }
    .bg-phone {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .gif-img {
      width: 360px;
      height: 780px;
      margin: 0 auto;
      margin-top: 63px;
      // background: red;
      // border-radius: 30px;
    }
  }
  .finally-step {
    padding-top: 128px;
    padding-bottom: 38px;
  }
}
.bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box; // 注意此处使用 padding 来做 ios 的屏幕适配，因此使用 content-box
  height: 130px;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
  background: #e5e5ff;
  .bar {
    width: $c-width;
  }
}
</style>
<style lang="scss">
@import './theme.scss';
</style>